module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("1. COFFEE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The aroma of coffee wafting through the house is just the incentive many need to throw off the covers and slide out of bed. The caffeine in coffee stimulates the brain by increasing energy metabolism and enhancing mood. Many people add milk, cream, or sugar to their coffee. Dairy promotes mucus formation, and sugar can depress the immune system. Avoid these pitfalls while still getting a great cup of coffee by substituting coconut oil. Add 1 or 2 teaspoons into freshly brewed coffee and stir until it has melted. Pour into a blender and turn to high for five seconds. This step is important to really mix the coconut oil into the coffee. Simply stirring can leave little dots of oil on the surface of the coffee that are not very appealing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coconut oil improves the metabolism of fats and reduces their storage in fat tissue."), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn6",
      "id": "fn6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" It encourages overall weight reduction, particularly in the abdominal area, and increases energy."), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn7",
      "id": "fn7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Coconut oil even nourishes the brain to enhance concentration and focus. The medium-chain fatty acids in the oil cross the blood-brain barrier where they are oxidized and used as a fuel source."), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn8",
      "id": "fn8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" Adding coconut oil to coffee will lift the mind’s morning fog and rev up the body’s metabolism to provide mental clarity and physical energy.")]), _vm._v(" "), _c('p', {
    staticClass: "img3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("2. COoKING AT HiGH HEAT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The high saturated fat content of coconut oil makes it ideal to use in cooking over the stovetop. It has a high smoke point, or the temperature at which the oil begins to give off a continuous wisp of smoke. The higher the smoke point, the more suited the oil is to cooking with heat. As oil heats, it is susceptible to oxidation, producing an off flavor in the oil and in the food being cooked. More importantly, however, when oil oxidizes, it produces compounds that may be toxic to the body, causing inflammation and damage. The more saturated the fat or oil is, the higher it can be heated before producing these offensive products. Coconut oil is more than 90 percent saturated, so using it to shallow-fry or sauté will ensure the intended flavors are reached without a detriment to health. Try this side dish using coconut oil to bring the ingredients together.")]), _vm._v(" "), _c('p', {
    staticClass: "h6"
  }, [_vm._v("CRuNCHY LEMoN QUINOA AND ASPARAGuS BOWL")]), _vm._v(" "), _c('p', {
    staticClass: "h7"
  }, [_c('a', {
    staticClass: "htt",
    attrs: {
      "href": "http://allrecipes.com",
      "target": "_blank"
    }
  }, [_vm._v("ALLRECiPES.COM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3a"
  }, [_vm._v("1 pound fresh asparagus, trimmed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("2 teaspoons coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1/2 onion, diced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1 cup cooked red quinoa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1/2 cup low-sodium vegetable stock")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1 tablespoon ground turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1/2 cup nutritional yeast")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("Juice of 1/2 large lemon")]), _vm._v(" "), _c('p', {
    staticClass: "num_list3"
  }, [_vm._v("1."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "numlist1_1"
  }, [_vm._v("Fill a saucepan halfway with water; bring to a boil. Add asparagus and cook uncovered until tender but still crispy, about 2–3 minutes. Drain in a colander and rinse with cold water to stop the cooking process.")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_vm._v("2."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "numlist1_1"
  }, [_vm._v("Heat coconut oil in a large skillet over medium heat. Add the onion and garlic; cook until onion is translucent, about 5 minutes. Stir in cooked quinoa, vegetable stock, and turmeric. Cook until flavors combine, about 5–6 minutes. Stir in blanched asparagus, nutritional yeast, and lemon juice. Cook and stir for 3–4 minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "img3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("3. DIETARY FAT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fats are nutrients essential to perform an abundance of functions in the body. They enhance the bioavailability of fat-soluble micro-nutrients and make up structural components in cell membranes and around nerves. Fats form hormones to regulate the body’s activities and are a concentrated source of energy. They provide a protective cushion around organs and insulation under the skin. Without an adequate supply of fats, the body could not function properly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The overwhelming majority of fats consumed consists of long-chain fatty acids and are found in meat, fish, dairy, nuts, and seeds. Included in this category are commonly used oils like olive, canola, safflower, and peanut. These fats are digested and made into triglycerides before entering the bloodstream. They are carried to fat cells for storage until they are needed for fuel. Many of these long-chain fatty acids are known to increase heart disease by elevating low-density lipoprotein cholesterol (LDL), known as bad cholesterol."), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn9",
      "id": "fn9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Coconut oil, on the other hand, is made up mostly of medium-chain fatty acids. These acids are directly absorbed from the small intestine into the bloodstream without being digested. They go to the liver and can be used immediately by the body for energy instead of being shunted into fat cells for storage. When consumed in moderation, medium-chain fatty acids actually help increase metabolism,"), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn10",
      "id": "fn10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" decrease body weight,"), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn11",
      "id": "fn11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" and raise the body’s high-density lipoprotein cholesterol (HDL)—also known as the good cholesterol."), _c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes#rfn12",
      "id": "fn12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" Substituting coconut oil for other fats and oils in the diet can protect the cardiovascular system and aid in weight loss.")]), _vm._v(" "), _c('p', {
    staticClass: "img3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("4. EGG FRESHNESS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eggs are eaten for breakfast, lunch, and dinner. They are used in both sweet and savory dishes, whether as the star of the show or as a welcome side dish. Eggs provide a low-calorie meal that is high in nutrients and flavor. Consequently, eggs are a staple in many homes and find their way onto almost every shopping list. The USDA recommends consuming eggs within five weeks after laying. Typically, eggs take a few days to reach the supermarket shelves and can sit there for weeks before being purchased. Over time, the freshness of eggs decreases, which can impact flavor. If left long enough, bacteria can break down the protein and create hydrogen sulfide gas, commonly known as the rotten egg smell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To preserve freshness, cover the eggs in a small amount of coconut oil. Eggs have thousands of tiny pores in the shell that can let in oxygen or bacteria. By sealing the pores with coconut oil, the egg is protected inside the shell and freshness is extended for several weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "img3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("5. HOMEMADE CHoCOLATE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chocolate inspires feelings of happiness and well-being in those who have conditioned their body to release dopamine as a reward for indulging in this sweet confection. This makes it very difficult to pass an aisle of chocolate bars or a pan of brownies on the counter without satisfying the craving a little. Every time we eat chocolate, we reinforce the positive feedback loop that releases dopamine in the brain and makes us feel good. This is a good thing, as long as chocolate is eaten in moderation. Too much can cause weight gain, but more distressing are the unhealthy compounds ingested with the average chocolate bar. Corn syrup and sugar are often the main ingredients. Hydrogenated oils, preservatives, and natural and artificial flavors usually make the list, too. These depress the immune system, are bad for the heart, and increase the workload of the liver. You may think natural flavors are okay, but often, they’re not. They begin with an ingredient found in nature, but by the time they are added to the food, they have been refined and altered to the point where they little resemble the starting product.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chocolate cravings can be satisfied while still getting a dopa-mine boost and consuming ingredients that nourish the body.")]), _vm._v(" "), _c('p', {
    staticClass: "h6"
  }, [_vm._v("HOMEMADE MELT-IN-yOUR-MoUTH DARK CHoCOLATE (PALEo)")]), _vm._v(" "), _c('p', {
    staticClass: "h7"
  }, [_c('a', {
    staticClass: "htt",
    attrs: {
      "href": "http://allrecipes.com",
      "target": "_blank"
    }
  }, [_vm._v("ALLRECiPES.COM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent3a"
  }, [_vm._v("1/2 cup coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1/2 cup cocoa powder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("3 tablespoons honey")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("1/2 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "num_list3"
  }, [_vm._v("1."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "numlist1_1"
  }, [_vm._v("Gently melt coconut oil in a saucepan over medium-low heat. Stir cocoa powder, honey, and vanilla extract into melted oil until well blended.")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_vm._v("2."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "numlist1_1"
  }, [_vm._v("Pour mixture into a candy mold or pliable tray.")])]), _vm._v(" "), _c('p', {
    staticClass: "num_list"
  }, [_vm._v("3."), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "numlist1_1"
  }, [_vm._v("Refrigerate until chilled, about 1 hour. Keep any leftovers in the refrigerator to maintain their shape.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07da839e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01_1.vue
// module id = 75
// module chunks = 0